import React from 'react';
import { ReactComponent as Star } from 'images/new-icons/rating-start.svg';
import s from './SpecialistRating.module.scss';
import clsx from 'clsx';

interface SpecialistRatingProps {
  rating: number;
  count?: number;
  showCount?: boolean;
  className?: string;
}

const SpecialistRating: React.FC<SpecialistRatingProps> = ({ 
  rating, 
  count = 0, 
  showCount = false,
  className 
}) => {
  if (rating <= 0) return null;

  return (
    <div className={clsx(s.rating, className)}>
      {showCount && <span className={s.count}>({count})</span>}
      <span className={s.number}>{rating.toFixed(1)}</span>
      <Star className={s.star} />
    </div>
  );
};

export default SpecialistRating;
